var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBath(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 0.046875C15.2943 0.046875 14.8711 0.157552 14.4805 0.378906C14.1029 0.60026 13.8034 0.90625 13.582 1.29688C13.3607 1.67448 13.25 2.09115 13.25 2.54688H12V3.79688H15.75V2.54688H14.5C14.5 2.16927 14.6107 1.86979 14.832 1.64844C15.0664 1.41406 15.3724 1.29688 15.75 1.29688C16.1276 1.29688 16.4271 1.41406 16.6484 1.64844C16.8828 1.86979 17 2.16927 17 2.54688V6.29688H0.125V7.54688H0.867188L1.82422 12.3125C1.90234 12.638 2.05208 12.9245 2.27344 13.1719C2.49479 13.4193 2.76172 13.5951 3.07422 13.6992L2.625 15.0469H3.875L4.28516 13.7969H14.7148L15.125 15.0469H16.375L15.9258 13.6992C16.2513 13.5951 16.5312 13.4193 16.7656 13.1719C17 12.9245 17.1562 12.638 17.2344 12.3125L18.1328 7.54688H18.875V6.29688H18.25V2.54688C18.25 2.09115 18.1393 1.67448 17.918 1.29688C17.6966 0.90625 17.3906 0.60026 17 0.378906C16.6224 0.157552 16.2057 0.046875 15.75 0.046875ZM2.13672 7.54688H16.8828L16.0039 12.0586C15.9648 12.2018 15.8867 12.319 15.7695 12.4102C15.6654 12.5013 15.5352 12.5469 15.3789 12.5469H3.67969C3.52344 12.5469 3.38672 12.5013 3.26953 12.4102C3.16536 12.306 3.09375 12.1823 3.05469 12.0391L2.13672 7.54688Z",
    fill: "#6B7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBath);
export default __webpack_public_path__ + "static/media/bath.0860c1a69c05509a85f817b2a99cb76f.svg";
export { ForwardRef as ReactComponent };